import cloneDeep from 'lodash/cloneDeep.js'

import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
  useSelector,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {
  EDIT_ADDITIONAL_OPTIONS_LABEL_ID,
  labelInfoSelector,
  removeLabelInfo,
  setLabelInfos,
  updateLabelInfo,
} from '../../../data/labelInfos/index.js'
import className from '../../../common/className.js'
import {SHIPPER_NAMES} from '../../../common/constants/ShipperNames.js'
import LabelConfigContext from '../LabelConfigContext.js'
import {AdditionalProperties} from '../LabelConfigForm.js'

const MODAL_FORM = 'EDIT_ADDITIONAL_OPTIONS_MODAL'

export function showEditAdditionalOptionsModal({
  labelInfoID,
  shipperType,
  onChange,
  isLabelEnableMode,
  enableMode,
}) {
  const labelInfo = labelInfoSelector(getState(), {labelInfoID})

  setLabelInfos([
    {
      ...labelInfo,
      id: EDIT_ADDITIONAL_OPTIONS_LABEL_ID,
      config: cloneDeep(labelInfo.config),
      properties: labelInfo.properties ? [...labelInfo.properties] : undefined,
    },
  ])

  setForm(MODAL_FORM, {
    labelInfoID,
    shipperType,
    onChange,
    isLabelEnableMode,
    enableMode,
    isSaving: false,
    serverError: null,
  })
}

export function updateModalForm(...args) {
  updateForm(MODAL_FORM, ...args)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export function modalFormSelector(state) {
  return formsSelector(state)[MODAL_FORM]
}

export function errorsSelector() {
  return {}
}

export async function confirm() {
  try {
    const {labelInfoID, onChange} = modalFormSelector(getState())
    const {config, properties} = labelInfoSelector(getState(), {
      labelInfoID: EDIT_ADDITIONAL_OPTIONS_LABEL_ID,
    })

    updateLabelInfo(labelInfoID, {config, properties})

    removeLabelInfo(EDIT_ADDITIONAL_OPTIONS_LABEL_ID)

    closeModal()

    showMessageToast('Updated.')

    await onChange()
  } catch (err) {
    updateModalForm({
      serverError: err.message || err.error_message,
      isSaving: false,
    })
  }
}

function onChange() {
  // noop
}

function EditAdditionalOptionsModal({form}) {
  const {shipperType, isLabelEnableMode, enableMode} = form
  const errors = useSelector(errorsSelector)

  return (
    <ConfirmModal
      title="Edit Additional Options"
      confirmText="Save"
      cancelText="Cancel"
      onConfirm={() => confirm()}
      onCancel={() => closeModal()}
      isSaving={form.isSaving}
      error={form.serverError}
      isDisabled={errors.preventSave}
    >
      <div
        className={className`wrap-shipper-addl-options fs-01 lh-md margin-bottom-15 ${shipperType}`}
      >
        <strong className="v-align-middle">
          Additional Options for {SHIPPER_NAMES[shipperType]}
        </strong>
      </div>
      <LabelConfigContext.Provider
        value={{
          contextID: MODAL_FORM,
          labelInfoID: EDIT_ADDITIONAL_OPTIONS_LABEL_ID,
          shipperType,
          onChange,
          isLabelEnableMode,
          enableMode,
        }}
      >
        <ul
          className={className`list list--shipping-options margin-bottom-15 ${
            isLabelEnableMode && 'wrap--label-enable-mode'
          }`}
        >
          <AdditionalProperties shipperTypes={[shipperType]} />
        </ul>
      </LabelConfigContext.Provider>
    </ConfirmModal>
  )
}

export default onlyIfForm(EditAdditionalOptionsModal, modalFormSelector)
